import { mapToApiServiceType } from './serviceTypeMapper';
import { mapToApiVehicleId } from '../sharedVehicleMappers';
import { mapToApiCollectedAccessories } from './accessoriesMapper';
import {
    ServiceOrderCompletion,
    ServiceOrdersCompletion,
    ServiceOrdersStartInfo,
    ServiceOrderStartInfo,
} from '../../../serviceOrders/serviceOrders/serviceOrderExecution.types';
import {
    ApiServiceOrderCompletion,
    ApiServiceOrdersCompletion,
    ApiServiceOrdersStartInfo,
    ApiServiceOrderStartInfo,
} from '../../types/serviceOrder/serviceOrderExecutionApi.types';
import { NonEmptyString } from 'io-ts-types';

// TODO PORTALOUT-3964 remove after using new endpoints in bulk dialog/sidebar
export const mapToApiServiceOrderStartInfos = (startInfo: ServiceOrderStartInfo): ApiServiceOrderStartInfo => ({
    type: mapToApiServiceType(startInfo.type),
    vehicle_id: mapToApiVehicleId(startInfo.vehicleId),
    started_at: startInfo.startedAt.toISOString(),
    general_information: startInfo.generalInformation,
    collected_accessories:
        startInfo.collectedAccessories !== undefined
            ? mapToApiCollectedAccessories(startInfo.collectedAccessories)
            : undefined,
});

export const mapToApiServiceOrdersStartInfos = (startInfo: ServiceOrdersStartInfo): ApiServiceOrdersStartInfo => ({
    order_ids: [...startInfo.orderIds] as NonEmptyString[],
    started_at: startInfo.startedAt.toISOString(),
    general_information: startInfo.generalInformation,
    collected_accessories:
        startInfo.collectedAccessories !== undefined
            ? mapToApiCollectedAccessories(startInfo.collectedAccessories)
            : undefined,
});

// TODO PORTALOUT-3964 remove after using new endpoints in bulk dialog/sidebar
export const mapToApiServiceOrderCompletion = (completion: ServiceOrderCompletion): ApiServiceOrderCompletion => ({
    type: mapToApiServiceType(completion.type),
    vehicle_id: mapToApiVehicleId(completion.vehicleId),
    started_at: completion.startedAt !== undefined ? completion.startedAt.toISOString() : undefined,
    completed_at: completion.completedAt.toISOString(),
    general_information: completion.generalInformation,
    collected_accessories:
        completion.collectedAccessories !== undefined
            ? mapToApiCollectedAccessories(completion.collectedAccessories)
            : undefined,
});

export const mapToApiServiceOrdersCompletion = (completion: ServiceOrdersCompletion): ApiServiceOrdersCompletion => ({
    order_ids: [...completion.orderIds] as NonEmptyString[],
    started_at: completion.startedAt !== undefined ? completion.startedAt.toISOString() : undefined,
    completed_at: completion.completedAt.toISOString(),
    general_information: completion.generalInformation,
    collected_accessories:
        completion.collectedAccessories !== undefined
            ? mapToApiCollectedAccessories(completion.collectedAccessories)
            : undefined,
});
